(function () {
  'use strict';

  var sticky = document.querySelector('[data-eclo-global-diagnostic-sticky]');
  if (!sticky) return;

  var threshold = parseFloat(sticky.getAttribute('data-threshold') || '0.35');
  if (!isFinite(threshold)) threshold = 0.35;

  var cornerOpen = false;
  var rafPending = false;
  var hookState = { open: null, close: null };

  function rootHasCartClass() {
    var value = ((document.documentElement && document.documentElement.className) || '') + ' ' + ((document.body && document.body.className) || '');
    return /(?:cart|drawer|cowi)[^ ]*(?:open|visible|active)|(?:open|visible|active)[^ ]*(?:cart|drawer|cowi)/i.test(value);
  }

  function broadcastCartOpen() {
    var drawer = document.getElementById('cart-drawer') || document.querySelector('[data-cart-drawer]');
    if (!drawer) return rootHasCartClass();
    if (drawer.hidden || drawer.getAttribute('aria-hidden') === 'true') return false;
    if (drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false') return true;
    if (/(?:is-|--)?(?:open|visible|active)|drawer--visible/i.test(drawer.className || '')) return true;
    return rootHasCartClass();
  }

  function cartIsOpen() {
    return cornerOpen || broadcastCartOpen();
  }

  function setVisible(visible) {
    sticky.hidden = !visible;
    document.documentElement.classList.toggle('eclo-global-diagnostic-sticky-visible', visible);
    if (visible) {
      document.documentElement.style.setProperty('--eclo-global-diagnostic-sticky-height', Math.ceil(sticky.getBoundingClientRect().height) + 'px');
    }
  }

  function renderNow() {
    rafPending = false;
    var maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    var progress = Math.max(0, window.scrollY) / maxScroll;
    var shouldShow = window.scrollY >= 300 && progress >= threshold && !cartIsOpen();
    setVisible(shouldShow);
  }

  function render() {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(renderNow);
  }

  function wrapCornerHooks() {
    if (window.onCowiOpen !== hookState.open) {
      var previousOpen = window.onCowiOpen;
      hookState.open = function () {
        cornerOpen = true;
        render();
        if (typeof previousOpen === 'function') return previousOpen.apply(this, arguments);
      };
      window.onCowiOpen = hookState.open;
    }

    if (window.onCowiClose !== hookState.close) {
      var previousClose = window.onCowiClose;
      hookState.close = function () {
        cornerOpen = false;
        render();
        if (typeof previousClose === 'function') return previousClose.apply(this, arguments);
      };
      window.onCowiClose = hookState.close;
    }
  }

  function observeCartState() {
    var drawer = document.getElementById('cart-drawer') || document.querySelector('[data-cart-drawer]');
    if (drawer && window.MutationObserver) {
      new MutationObserver(render).observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'open'] });
    }

    if (window.MutationObserver) {
      var observer = new MutationObserver(render);
      if (document.documentElement) observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.addEventListener('scroll', render, { passive: true });
  window.addEventListener('resize', render);
  window.addEventListener('pageshow', render);
  document.addEventListener('shopify:section:load', render);

  wrapCornerHooks();
  var hookRetries = 0;
  var hookTimer = window.setInterval(function () {
    wrapCornerHooks();
    hookRetries += 1;
    if (hookRetries >= 10) window.clearInterval(hookTimer);
  }, 500);

  observeCartState();
  render();
})();
